import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getRepairParts, getSparePartsList } from "../../api/apiGetrequest";
import { UpdateRepairParts } from "../../api/apirequest";
import TruckLoader from "../../Components/ProgressBar/Loader";

const styles = {
  container: {
    width: "100%",
    padding: "16px",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
  },
  formGroup: {
    marginBottom: "16px",
  },
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    color: "#1a202c",
    marginBottom: "8px",
  },
  inputWrapper: {
    position: "relative",
    flexGrow: 1,
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #cbd5e0",
    borderRadius: "6px",
    fontSize: "14px",
    outline: "none",
  },
  button: {
    padding: "8px 16px",
    backgroundColor: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "8px",
  },
  editButton: {
    padding: "4px 8px",
    backgroundColor: "#10b981",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    marginRight: "8px",
  },
  saveButton: {
    padding: "4px 8px",
    backgroundColor: "#6366f1",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    marginRight: "8px",
  },
  suggestionsContainer: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    marginTop: "4px",
    background: "white",
    border: "1px solid #e2e8f0",
    borderRadius: "6px",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    maxHeight: "240px",
    overflowY: "auto",
    zIndex: 10,
  },
  suggestionItem: {
    padding: "8px 12px",
    cursor: "pointer",
    backgroundColor: "white",
    transition: "background-color 0.2s",
  },
  partsList: {
    marginTop: "16px",
  },
  partItem: {
    padding: "8px 0",
    color: "#2d3748",
    borderBottom: "1px solid #e2e8f0",
  },
  deleteButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#ff3b3b",
    cursor: "pointer",
    padding: "4px 8px",
    fontSize: "12px",
  },
  editField: {
    width: "100px",
    padding: "4px 8px",
    marginRight: "8px",
    border: "1px solid #cbd5e0",
    borderRadius: "4px",
  },
};

const SparePartInput = ({
  onAdd,
  repair,
  spareParts,
  setSpareParts,
  fetchRepairs,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [cost, setCost] = useState(0);
  const [comment, setComment] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editData, setEditData] = useState({ SpareCost: 0, Comment: "" });
  const [isLoading, setIsLoading] = useState(true);

  const filteredSuggestions = Array.isArray(suggestions)
    ? suggestions.filter((item) =>
        item?.SparePart?.toLowerCase()?.includes(inputValue?.toLowerCase())
      )
    : [];

console.log('repair', repair)

  const fetchRepairParts = async () => {
    try {
      setIsLoading(true);
      const { result: parts } = await getRepairParts(repair?.RepairID);
      const { result } = await getSparePartsList(
        repair?.Model === "" ? "Truck" : repair.Model
      );
      setSuggestions(result || []);
      setSpareParts(parts || []);
      setIsLoading(false);
    } catch (error) {
      // toast.error("Failed to fetch repairs");
      setSuggestions([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (repair?.RepairID) {
      fetchRepairParts();
    } else {
      setSuggestions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repair?.RepairID]);

  const handleAdd = () => {
    const newPart = inputValue.trim();
    if (newPart) {
      if (
        spareParts.some(
          (part) => part.SparePart.toLowerCase() === newPart.toLowerCase()
        )
      ) {
        toast.warning("This spare part has already been added");
        return;
      }

      const matchingSuggestion = suggestions?.find(
        (s) => s?.SparePart?.toLowerCase() === newPart.toLowerCase()
      );

      const newSparePart = {
        SparePart: newPart,
        SpareCost: matchingSuggestion ? matchingSuggestion.SpareCost : 0,
        Comment: comment || "",
      };

      setSpareParts([...spareParts, newSparePart]);
      onAdd(newSparePart);

      setInputValue("");
      setCost(0);
      setComment("");
      setShowSuggestions(false);
    } else {
      toast.warning("Please enter a spare part name");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleAdd();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    if (
      !spareParts.some(
        (part) =>
          part.SparePart.toLowerCase() === suggestion.SparePart.toLowerCase()
      )
    ) {
      const newSparePart = {
        SparePart: suggestion.SparePart,
        SpareCost: suggestion.SpareCost || 0,
        Comment: comment || "",
      };
      setSpareParts([...spareParts, newSparePart]);
      onAdd(newSparePart);

      setInputValue("");
      setCost(0);
      setComment("");
      setShowSuggestions(false);
    } else {
      toast.warning("This spare part has already been added");
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditData({
      SpareCost: spareParts[index].SpareCost || 0,
      Comment: spareParts[index].Comment || "",
    });
  };

  const handleSaveEdit = async (row, deleteFlag) => {
    try {
      const result = await UpdateRepairParts({
        repairPartID: row.RepairPartID,
        repairID: row.RepairID,
        sparePart: row.SparePart,
        spareCost: editData.SpareCost || row.SpareCost,
        comment: editData.Comment || row.Comment,
        dateAdded: new Date(),
        statusID: deleteFlag ? 0 : row.StatusID,
      });

      if (result.success) {
        setEditingIndex(null);
        fetchRepairParts();
        toast.success("Updated successfully");
      } else {
        toast.error(result.message || "Update failed");
      }
    } catch (error) {
      toast.error("Failed to update repair");
    } finally {
      // Note: You might want to uncomment or remove this line based on your usage
      // onUpdate(updatedParts);
    }
  };

  const handleDelete = (index) => {
    const newParts = [...spareParts];
    newParts.splice(index, 1);
    setSpareParts(newParts);
    onAdd(null, index);
  };

  return (
    <div style={styles.container}>
      {/* {repair?.StatusID > 1 && ( */}
        <>
          {isLoading ? (
            <div style={{ ...styles.formGroup, textAlign: "center" }}>
              <TruckLoader />
              {/* Loading spare parts... */}
            </div>
          ) : (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>Spare Parts</label>
                <div style={styles.inputContainer}>
                  <div style={styles.inputWrapper}>
                    <input
                      style={styles.input}
                      type="text"
                      placeholder="Enter spare part used..."
                      value={inputValue}
                      onChange={(e) => {
                        setInputValue(e.target.value);
                        setShowSuggestions(true);
                      }}
                      onKeyPress={handleKeyPress}
                      onFocus={() => setShowSuggestions(true)}
                      onBlur={() =>
                        setTimeout(() => setShowSuggestions(false), 200)
                      }
                    />
                    {showSuggestions && inputValue && (
                      <div style={styles.suggestionsContainer}>
                        {filteredSuggestions?.length > 0 ? (
                          filteredSuggestions.map((suggestion, index) => (
                            <div
                              key={index}
                              style={styles.suggestionItem}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#f7fafc";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "white";
                              }}
                              onClick={() => handleSuggestionClick(suggestion)}
                            >
                              {suggestion.SparePart} -{" "}
                              {suggestion.SpareCost || 0}
                            </div>
                          ))
                        ) : (
                          <div style={styles.suggestionItem}>
                            No matching suggestions (click Add to create new)
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <button
                    style={styles.button}
                    onClick={handleAdd}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#2563eb";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#3b82f6";
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>

              <div style={styles.partsList}>
                {spareParts.map((part, index) =>
                 
                    <div key={index} style={styles.partItem}>
                      <div style={{fontWeight: 'bold'}}>
                        {index + 1}. {part.SparePart}
                      </div>
                      {editingIndex === index ? (
                        <div style={{ marginTop: "8px" }}>
                          <input
                            style={styles.editField}
                            type="number"
                            value={editData.SpareCost}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                SpareCost: parseFloat(e.target.value) || 0,
                              })
                            }
                            placeholder="Cost"
                          />
                          <input
                            style={styles.editField}
                            type="text"
                            value={editData.Comment}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                Comment: e.target.value,
                              })
                            }
                            placeholder="Comment"
                          />
                          <button
                            style={styles.saveButton}
                            onClick={() => handleSaveEdit(part)}
                          >
                            Save
                          </button>
                        </div>
                      ) : (
                        <div style={{ marginTop: "8px" }}>
                          Cost:{" "}
                          {new Intl.NumberFormat("en-KE", {
                            style: "currency",
                            currency: "KES",
                          }).format(part.SpareCost)}
                          , Comment: {part.Comment}
                          <button
                            style={styles.editButton}
                            onClick={() => handleEdit(index)}
                          >
                            Edit
                          </button>
                          <button
                            style={styles.deleteButton}
                            onClick={() => handleSaveEdit(part, true)}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  
                )}
              </div>
            </>
          )}
        </>
      {/* )} */}
    </div>
  );
};

export default SparePartInput;
